import { render, staticRenderFns } from "./CertificationsPageSelectUsers.vue?vue&type=template&id=67c82526&"
import script from "./CertificationsPageSelectUsers.vue?vue&type=script&lang=ts&"
export * from "./CertificationsPageSelectUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c82526')) {
      api.createRecord('67c82526', component.options)
    } else {
      api.reload('67c82526', component.options)
    }
    module.hot.accept("./CertificationsPageSelectUsers.vue?vue&type=template&id=67c82526&", function () {
      api.rerender('67c82526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/CertificationsPageSelectUsers.vue"
export default component.exports